import Button from "../../components/seller-hub/buttons/Button";
import Header from "../../components/seller-hub/header/Header";
import Card from "../../components/seller-hub/wallet/Card";
import Seller from "../../layouts/seller-hub/Seller";
// import { useState } from "react";
import Search from "../../components/seller-hub/wallet/Search";
import DropDown from "../../components/seller-hub/wallet/DropDown";
import arrowDown from "../../assets/arrow-down.png";
import Table from "../../components/seller-hub/wallet/Table";
import TableRow from "../../components/seller-hub/wallet/TableRow";
import Pagination from "../../components/seller-hub/pagination/Pagination";
import { openBackdropWithoutData } from "../../slice/sellerHub/sellerhubSlice";
import { useDispatch } from "react-redux";

const SellerWallet = () => {
  const dispatch = useDispatch();
  // const [walletFilter, setWalletFilter] = useState(null);
  // const walletFilterOptions = ["This Week", "Last Week", "This Month"];

  const dummyArr = [
    {
      date: "17/05/2022",
      referenceId: "Qwerty5000",
      amount: "₦20,000",
      transactionType: "Inflow",
      status: "Successful",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty1234",
      amount: "₦20,000",
      transactionType: "Inflow",
      status: "Successful",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty1234",
      amount: "₦20,000",
      transactionType: "Inflow",
      status: "Successful",
    },
    {
      date: "17/05/2022",
      referenceId: "Qwerty1234",
      amount: "₦20,000",
      transactionType: "Inflow",
      status: "Successful",
    },
  ];

  return (
    <>
      <div className="-mt-20 w-full pb-5">
        <Header />
        <Seller>
          <div className="mt-4 flex justify-between items-center">
            <h4 className="font-Lato font-bold text-xl">Wallet</h4>
            <Button
              innerText="Withdraw"
              width="w-[109px]"
              onclick={() => dispatch(openBackdropWithoutData())}
            />
          </div>

          <div className="mt-5 flex gap-3 flex-wrap">
            <Card
              headerText="Wallet Balance"
              amount="4,500"
              dropdown={true}
              height="h-[171.22px]"
            />
            <Card
              headerText="Available Balance"
              amount="2,000"
              dropdown={true}
              height="h-[171.22px]"
            />
            <Card
              headerText="Holding Balance"
              amount="500"
              dropdown={true}
              height="h-[171.22px]"
            />
          </div>

          <div className="mt-8 flex flex-col md:flex-row justify-between">
            <Search />
            <div className="flex flex-wrap gap-3 mt-3 md:mt-0">
              <DropDown
                additionalClass="h-[44px]"
                innerText="Transaction type"
                icon={[
                  <img key={Math.random()} src={arrowDown} alt="arrow down" />,
                ]}
              />
              <DropDown
                additionalClass="h-[44px]"
                innerText="Filter by date"
                icon={[
                  <img key={Math.random()} src={arrowDown} alt="arrow down" />,
                ]}
              />
              <DropDown
                additionalClass="h-[44px]"
                innerText="Download"
                icon={[
                  <svg
                    key={Math.random()}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-file-earmark-medical"
                    viewBox="0 0 16 16"
                  >
                    <path d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z" />
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                  </svg>,
                ]}
              />
            </div>
          </div>

          <div className="mt-8 pt-2 border-t-[0.5px] border-l-[0.5px] border-r-[0.5px] rounded-tr rounded-tl border-[#DEE2F3] ">
            <h4 className="text-lg font-Lato font-bold pl-2">
              Inventory Manager
            </h4>
            <div className="overflow-scroll xl:overflow-auto scrollbar-none">
              <div className="w-[820px] xl:w-auto">
                <div className="mt-3 pl-2">
                  <Table />
                </div>
                <div className="">
                  {dummyArr.map((arr, index) => (
                    <TableRow key={Math.random()} data={arr} index={index} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="h-[72px] flex justify-between items-center pl-2 pr-2 border-[0.5px] rounded-bl rounded-br border-[#DEE2F3]">
            <p className="text-sm text-[#757575]">Page 1 to 10</p>
            <Pagination />
          </div>
          <div className="flex justify-end mt-5">
            <Button
              width="w-[129px]"
              innerText="New Item"
              icon={[
                <svg
                  key={Math.random()}
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-square w-6 h-6"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>,
              ]}
            />
          </div>
        </Seller>
      </div>
    </>
  );
};

export default SellerWallet;
